import { createActionGroup, emptyProps, props } from '@ngrx/store';

export interface SharedMessagePayload {
  error?: string;
  warning?: string;
  success?: string;
  info?: string;
}

export const SharedActions = createActionGroup({
  source: 'SHARED',
  events: {
    'Reset to Initial state': emptyProps(),
    'Show Message': props<SharedMessagePayload>(),
  },
});
